export const formatGradient = (value) => {
    const {
        colors, ratios, rotate, fixChubb
    } = value;

    const params = { rotate, fixChubb };

    if (colors instanceof Array) {
        const [color0, color1] = colors;

        params.color0 = color0;
        params.color1 = color1;
    }

    if (ratios instanceof Array) {
        const [ratio0, ratio1] = ratios;

        params.ratio0 = ratio0;
        params.ratio1 = ratio1;
    }

    return params;
};
